import React, { useEffect } from 'react'
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { connect } from "react-redux";
import { Card, CardBody, CardTitle } from "reactstrap";


// components
import CampaignForm from "./_form";
import { ModalFormContainer } from "../../../components/confirmAlert/ModalFormContainer";
import { GenericTableButton } from "../../../components/buttons/buttonsActions";
import PropuestaSlide from "../Slide/PropuestaSlide";
import SlideList from "../Slide/_list";
import SlideForm from "../Slide/_form";

// labels
import {
    LB_ACTIONS, LB_ACTIVE,
    LB_CODE, LB_END_DATE, LB_START_DATE, LB_TITLE,
    LIST, NO_DATA_FOUND
} from "../../../components/i18n/i18n";
import { TT_DELETE, TT_EDIT } from "../../../components/i18n/toolTips";


// actions
import { setFilter, setTableParams } from "../../../redux/actions/generalActions/listActions";
import { setViewMode } from "../../../redux/actions/generalActions/mainActions";
import { setForm, setItem } from "../../../redux/actions/generalActions/formActions";
import { genericActions } from "../../../redux/actions/generics/GenericActions";


// services
import { campaignService } from "../../../jwt/_services/campaign/campaignService";
import CampaignFilters from "./_filters";
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";


const CampaignList = props => {
    const { app } = props.mainProps
    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps


    // asignar los valores por default del filtro
    useEffect( () => {
        if(!fbDataBaseId || filter)
            return

        props.setFilter( {
            onlyRegistered : true,
            fbDataBase: { id: `${fbDataBaseId}` },
            item: { code:null }
        } )
    }, [ fbDataBaseId ])



    // realizar búsqueda cuando cambie el filtro
    useEffect(() => {
        if(!filter)
            return

        genericActions.search(campaignService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter ]);



    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };


    const confirmDelete = (data) => {
        return ConfirmDelete({ remove : genericActions.remove , data : data, fbDataBaseId :  app?.fbDataBase?.id, service: campaignService } );
    };

    const editItem = (data) => {
        props.setForm(true, false, false);
        props.setItem(data);
        ModalFormContainer(CampaignForm, { data, Form: CampaignForm })
    }

    const editSlide = (data) => {
        props.setItem(data);
        props.setForm(true, false, false)
        ModalFormContainer(PropuestaSlide, { data, Form: SlideForm, List: SlideList, closeOnClickOutside : true })
    }

    const actionsFormatter = (cell, row) => <div key={`action-${row?.id}`}>
        <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
        <GenericTableButton toolTip={"Slides"} icon={'fa-images'} permission={'edit'} onClick={() => editSlide(row)}/>
        <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </div>


    const activeFormatter = cell => <ActiveFormatter active={cell} />



    const columns = [
        {
            dataField: 'id',
            headerStyle: { width: '0px'},
            text: 'ID',
            hidden: true
        }, {
            dataField: 'uid',
            text: `UID`,
            headerStyle: {width: '200px'},
            headerAlign: 'center',
            align:'center',
        }, {
            dataField: 'code',
            text: `${LB_CODE}`,
            headerStyle: {width: '150px'},
        }, {
            dataField: 'title',
            text: `${LB_TITLE}`
        }, {
            dataField: 'startDate',
            text: `${LB_START_DATE}`,
            headerStyle: {width: '150px'},
            headerAlign: 'center',
            align:'center',
        }, {
            dataField: 'endDate',
            text: `${LB_END_DATE}`,
            headerStyle: {width: '150px'},
            headerAlign: 'center',
            align:'center',
        }, {
            dataField: 'status',
            text: `${LB_ACTIVE}`,
            headerStyle: {width: '50px'},
            headerAlign: 'center',
            align:'center',
            formatter: activeFormatter
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: `${LB_ACTIONS}`,
            headerStyle: {width: '250px'},
            headerAlign: 'center',
            align:'center',
            formatter: actionsFormatter
        }
    ];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
        </CardTitle>

        <CampaignFilters />

        <CardBody className="">
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={columns}
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
})
export default connect(mapStateToProps, mapActionsToProps)(CampaignList)